import React from "react";
import { getPrice } from "../utils/pricing";

export default function OrderList({ orders = [], onReload }) {
  let totalPrice = 0;

  async function handleDelete({ name, size, type, sauces }) {
    if (!window.confirm(`Ištrinti ${name} užsakymą?`)) return;
    try {
      const res = await fetch("https://worker.kebatic.org/delete", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, size, type, sauces }),
      });
      if (res.ok) {
        onReload && onReload();
      } else {
        alert("Nepavyko ištrinti: " + (await res.text()));
      }
    } catch (e) {
      alert("Tinklo klaida.");
    }
  }

  if (!orders.length) {
    return (
      <section className="card orders-section">
        <h3 className="section-title" data-i18n="current_orders">Dabartiniai užsakymai</h3>
        <div className="orders-empty">
          <span className="orders-empty-icon">🌯</span>
          Kol kas užsakymų nėra.
        </div>
      </section>
    );
  }

  orders.forEach(order => {
    const price = getPrice(order.size, order.type);
    totalPrice += Number(price) * Number(order.count || 0);
  });

  totalPrice += 0.1;

  return (
    <section className="card orders-section">
      <h3 className="section-title" data-i18n="current_orders">Dabartiniai užsakymai</h3>
      {orders.map((order, idx) => {
        const price = getPrice(order.size, order.type).toFixed(2);
        return (
          <div className="order" key={order.size + order.type + order.sauces + idx}>
            <div className="order-header">
              <span className="order-badge">{order.count}x</span>
              <div className="order-details">
                {order.size}, {order.type}
                {order.sauces ? ` · ${order.sauces}` : " · Be padažo"}
                <div className="order-meta">
                  <strong>{price} EUR</strong> / vnt
                  {order.order_date && (
                    <> · {order.order_date}</>
                  )}
                </div>
              </div>
            </div>
            <div className="order-names">
              <div className="order-names-label">Užsakymai</div>
              {order.name.map((name, nidx) => (
                <div className="order-name-row" key={name + nidx}>
                  <span>{name}</span>
                  <button
                    className="btn-delete"
                    type="button"
                    onClick={() =>
                      handleDelete({
                        name,
                        size: order.size,
                        type: order.type,
                        sauces: order.sauces,
                      })
                    }
                  >
                    Ištrinti
                  </button>
                </div>
              ))}
            </div>
          </div>
        );
      })}
      <div className="total-card">
        <strong>VISO: {Number(totalPrice).toFixed(2)} EUR</strong>
      </div>
    </section>
  );
}
